import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routers.js'
import store from './store/index.js'

const app = createApp(App)
app.use(router) // 注册路由
app.use(store)  // 注册状态管理
app.mount('#app')